module.exports = __webpack_public_path__ + "img/user-male.e67e358c.png";